import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import PrimaryBox from '../../components/layout/PrimaryBox';
import FormsUsersAccessTable from '../../components/tables/qhse/forms/FormsUsersAccessTable';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';

const FormsUsersAccessPage: React.FC = () => {
    const { t } = useTranslation();

    usePageTitle(capitalizeFirstLetter(t('formsUsersAccess')));

    return (
        <PrimaryBox>
            <Header
                title={t('qhse')}
                breadcrumbs={[
                    { label: capitalizeFirstLetter(t('forms')), link: '/qhse/forms' },
                    { label: capitalizeFirstLetter(t('formsUsersAccess')) },
                ]}
                subTitle={capitalizeFirstLetter(t('formsUsersAccess'))}
                isDateVisible={false}
            ></Header>
            <FormsUsersAccessTable />
        </PrimaryBox>
    );
};

export default FormsUsersAccessPage;
